// @flow
import React, { type Element } from 'react';
import { Button } from 'angieslist-react-components';
import './reviewRetort.scss';

type Props = {
  text: ?string,
  reviewId: string,
  handleEdit: () => void,
};

const ReviewRetortDisplayComponent = ({
  text, reviewId, handleEdit,
}: Props): Element<"div"> => (
  <div className="review-card_retort">
    <h3 className="review-card_retort_section-heading">Service Provider Response:
      <Button
        id={`review-card--retort--desktop-edit-button-${reviewId}`}
        flat
        ghost
        className="hidden-xs review-card_retort-button"
        bsSize="small"
        style={{ marginLeft: '1em', paddingLeft: '.5em' }}
        onClick={handleEdit}
      ><i className="icon icon-pencil" /> Edit
      </Button>
    </h3>
    <blockquote className="review-card_retort_blockquote">{text}</blockquote>
    <Button
      id={`review-card--retort--mobile-edit-button-${reviewId}`}
      flat
      block
      className="visible-xs review-card_retort-button"
      bsSize="small"
      style={{ marginTop: '.5em', paddingLeft: '.5em' }}
      onClick={handleEdit}
    ><i className="icon icon-pencil" /> Edit
    </Button>
  </div>
);

export default ReviewRetortDisplayComponent;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/ReviewRetortDisplay.js